import { absolutePath } from "./absolutePath";

interface CommunitiesFnProps {
  communityId?: string;
  communityLinkId?: string;
  communitySettingId?: string;
  forceFromSubscription?: boolean;
  params?: Record<string, unknown>;
}

export const communities = {
  create: ({ params = {} }: CommunitiesFnProps = {}) =>
    absolutePath("communities", params),
  show: ({ params = {} }: CommunitiesFnProps = {}) =>
    absolutePath("communities", params),
  update: ({ params = {} }: CommunitiesFnProps = {}) =>
    absolutePath("communities", params),
  communityAiSettings: {
    show: ({ params = {} }: CommunitiesFnProps = {}) =>
      absolutePath("community_ai_settings", params),
    languages: ({ params = {} }: CommunitiesFnProps = {}) =>
      absolutePath("community_ai_settings/languages", params),
    update: ({ params = {} }: CommunitiesFnProps = {}) =>
      absolutePath("community_ai_settings", params),
  },
  communitySettings: {
    index: ({ params = {} }: CommunitiesFnProps = {}) =>
      absolutePath("community_settings", params),
    update: ({ communitySettingId, params = {} }: CommunitiesFnProps = {}) =>
      absolutePath(`community_settings/${communitySettingId}`, params),
  },
  communityLinks: {
    create: () => absolutePath("community_links"),
    update: ({ communityLinkId }: CommunitiesFnProps) =>
      absolutePath(`community_links/${communityLinkId}`),
    delete: ({ communityLinkId }: CommunitiesFnProps) =>
      absolutePath(`community_links/${communityLinkId}`),
    reorder: () => absolutePath("community_links/reorder"),
  },
  onboarding_settings: {
    show: ({ params = {} }: CommunitiesFnProps = {}) =>
      absolutePath("community_onboarding_settings", params),
    update: ({ params = {} }: CommunitiesFnProps = {}) =>
      absolutePath("community_onboarding_settings", params),
  },
  customInvitationEmail: {
    show: ({ params = {} }: CommunitiesFnProps = {}) =>
      absolutePath("communities/custom_invitation_email", params),
    update: ({ params = {} }: CommunitiesFnProps = {}) =>
      absolutePath("communities/custom_invitation_email", params),
    scanStatus: ({ params = {} }: CommunitiesFnProps = {}) =>
      absolutePath("communities/custom_invitation_email/scan_status", params),
  },
  templates: {
    index: ({ communityId, params = {} }: CommunitiesFnProps = {}) =>
      absolutePath(`communities/${communityId}/templates`, params),
    create: ({ communityId, params = {} }: CommunitiesFnProps = {}) =>
      absolutePath(`communities/${communityId}/templates`, params),
  },
  questions: {
    create: ({ communityId, params = {} }: CommunitiesFnProps = {}) =>
      absolutePath(`communities/${communityId}/questions`, params),
  },
  plans: {
    show: ({ forceFromSubscription = false }: CommunitiesFnProps) =>
      absolutePath(`communities/plans`, {
        force_from_subscription: forceFromSubscription,
      }),
  },
  checklist: {
    show: ({ params = {} }: CommunitiesFnProps = {}) =>
      absolutePath("communities/checklist", params),
    update: ({ params = {} }: CommunitiesFnProps = {}) =>
      absolutePath("communities/checklist", params),
    broadcast: ({ params = {} }: CommunitiesFnProps = {}) =>
      absolutePath("communities/checklist/broadcast", params),
    defaultAccessGroup: ({ params = {} }: CommunitiesFnProps = {}) =>
      absolutePath("communities/checklist/default_access_group", params),
  },
  onboardingFlags: {
    update: ({ flag }: { flag: string }) =>
      absolutePath(`communities/onboarding_flags/${flag}/enable`),
  },
  experimentationFlags: {
    show: () => absolutePath(`communities/experimentation/flags`),
  },
};
